import apiClient from './apiClient'
const config = Object.freeze({
  baseURL: process.env.YQZ_CAMERA_API
})

export async function getProjectCameraList(
  companyId,
  projectId,
  onlineDeviceFlag
) {
  const res = await apiClient.post(
    '/devices/management/list',
    {
      companyId,
      projectId,
      onlineDeviceFlag
    },
    {...config}
  )
  return res.data
}

export async function getCameraToken(deviceSerial) {
  const res = await apiClient.post(
    '/cloud/device/token/get',
    { deviceSerial },
    {...config}
  )
  return res.data
}

export async function getCommunityCameraProjectList(companyId, communityId) {
  const res = await apiClient.post('map/project/list', {
    companyId,
    communityId
  })
  return res.data
}

export async function getScreenList(companyId, type) {
  const res = await apiClient.post('devices/binding/project/list', {
    companyId,
    type
  })
  return res.data
}

export async function verifyPassword(companyId, password) {
  const res = await apiClient.post('devices/verify/password', {
    companyId,
    password
  })
  return res.data
}
